'use strict';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { HarrowFooterComponent } from './harrow-footer.component';
import { HarrowFooterService } from './harrow-footer.service';
import { SafeHtmlModule } from '../../../services/safeHtml';
import {
  MatButtonModule, MatCheckboxModule, MatCardModule, MatToolbarModule, MatSidenavModule, MatIconModule, MatInputModule, MatRadioModule, MatFormFieldModule, MatAutocompleteModule,
  MatSelectModule, MatDatepickerModule, MatNativeDateModule, DateAdapter
} from '@angular/material';
import { FooterService } from '../../../footer/footer.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    MatButtonModule, MatCheckboxModule, MatInputModule, MatRadioModule, MatCardModule, MatToolbarModule, MatSidenavModule,
    MatIconModule, MatFormFieldModule, MatSelectModule, MatDatepickerModule, MatNativeDateModule, MatAutocompleteModule, FlexLayoutModule,
    SafeHtmlModule
  ],
  exports: [HarrowFooterComponent],
  declarations: [HarrowFooterComponent],
  providers: [FooterService, HarrowFooterService]
})
export class HarrowFooterModule {}



// WEBPACK FOOTER //
// ./src/app/customizations/harrow/footer/harrow-footer.module.ts